<template>
  <div
    class="min-vh-100 w-100 d-flex flex-column align-items-center
    position-relative"
  >
    <div class="position-absolute error-div">
      <div class="card d-flex error-card">
        <div class="card-body align-items-center d-flex justify-content-center">
          <span class="d-inline-block">
            <b-icon-exclamation-triangle-fill class="icon-error" />
          </span>
          <span class="d-inline-block">
            {{ errorMsg }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // eslint-disable-next-line
      errorMsg: 'Currently, this browser is not supported. Please reconnect using the Chrome browser.',
    };
  },
  created() {
    if (this.$route.name === 'TimeOut') {
      this.errorMsg = 'Authorization token expired.';
    } else if (this.$route.name === 'InvalidAuth') {
      this.errorMsg = 'Invalid authorization token.';
    }
  },
};
</script>

<style lang="scss" scoped>

.error-div{
  max-width:780px;
  width:auto;
  position: absolute;
  top:50%;
  left:50%;
  -webkit-transform: translate(-50%,-50%);
  transform: translate(-50%,-50%);
}

.error-card{
  padding: 1rem 3rem;
}

.icon-error{
  width: 8rem;
  height: 8rem;
}
</style>
